export const getSystemConfigValue = (systemConfigs, category, keyname) => {
  const entry = systemConfigs.find((c) => c.category === category && c.keyname === keyname) || {};
  return entry.value;
};
